<template>
	<div style="padding:12px;">
		<hr-documents-list :hr-documents="hrPolicies" :is-admin="loggedInEmployee.isAdmin" />

		<v-subheader v-show="hrPolicies === null || hrPolicies.length === 0" class="mt-3">
			No company policies have been setup
		</v-subheader>

		<v-footer color="" app height="55">
			<v-spacer></v-spacer>
			<footer-add-btn v-if="$_hasAccessToFeature($FeatureId.COMPANY_POLICIES_MANAGE, $PermissionAction.USE)" @click="addDocument" color="primary">
				Add New Policy
			</footer-add-btn>
		</v-footer>

		<create-hr-document-modal
			:is-admin="loggedInEmployee.isAdmin"
			:dialog="showCreateHrDocumentModal"
			:policy-templates="hrPolicyTemplates"
			:logged-in-tenant="loggedInTenant"
			@onBlankPolicySelected="onBlankPolicySelected"
			@onPolicySelected="onPolicySelected"
			@onPackSelected="onPackSelected"
			@closeModal="showCreateHrDocumentModal = !showCreateHrDocumentModal"
		/>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import HrDocumentsList from '@/components/hrDocuments/HrDocumentsList';
	import CreateHrDocumentModal from '@/components/hrDocuments/CreateHrDocumentModal';

	export default {
		data() {
			return {
				isLoading: false,
				showCreateHrDocumentModal: false
			};
		},
		components: {
			HrDocumentsList,
			CreateHrDocumentModal
		},
		created() {
			this.isLoading = true;
			this.$store.dispatch('setPageTitle', 'Company Policies');
		},
		computed: {
			...mapGetters({
				hrPolicies: 'hrDocuments/hrPolicies',
				loggedInEmployee: 'loggedInEmployee',
				loggedInTenant: 'loggedInTenant',
				hrPolicyTemplates: 'marketplace/hrPolicyTemplates'
			})
		},
		methods: {
			addDocument() {
				this.showCreateHrDocumentModal = true;
			},
			onBlankPolicySelected() {
				this.$router.push('/hrDocument/create/');
			},
			onPolicySelected(policyTemplate) {
				this.$store.dispatch('hrDocuments/useTemplate', policyTemplate.id).then(
					response => {
						this.$router.push(`/hrDocuments/${response.id}`);
					},
					err => {}
				);
			},
			onPackSelected() {
				this.$router.push('/hrDocument/create/');
			}
		}
	};
</script>

<style></style>
